import { formatCurrency as formatCurrencyFormatters } from "./formatters";

// Centralizovaná funkcia pre formátovanie meny v klientskej časti
export function formatCurrency(amount: number, currency: 'EUR' | 'USD' = 'EUR'): string {
  return formatCurrencyFormatters('sk', amount, currency);
}

// Helper pre získanie symbolu meny
export function getCurrencySymbol(currency: 'EUR' | 'USD'): string {
  return currency === 'USD' ? '$' : '€';
}

// Helper pre získanie locale kódu
export function getLocaleCode(currency: 'EUR' | 'USD'): string {
  return currency === 'USD' ? 'en-US' : 'sk-SK';
}